import React, {Component} from "react";
import {MyButton} from "./ItemsLoader";
import {LoadingImage} from "./App";
import {supabase} from "./supabaseClient";
import "./Styles/card.css"
import "./Styles/inputField.css"

interface Comment {
    Name:string,
    Comment:string,
}

interface CommentsState{
    commentsDownloaded:boolean
    Comments:Comment[]
}
class Comments extends Component<any, CommentsState>{

    constructor(props:any) {
        super(props);
        this.state = {
            commentsDownloaded:false,
            Comments:[]
        }
    }

    name = "";
    comment = "";


    componentDidMount() {
        this.getComments();
    }

    async getComments(){
        const {data, error} = await supabase
            .from('comments')
            .select('author_name, comment')
            .eq('context', this.props.type)
            .order('created_at', {ascending: false});

        if (error) {
            console.log(error);
            this.setState({commentsDownloaded: true});
            return;
        }

        const comments: Comment[] = (data || []).map((row: any) => ({
            Name: row.author_name,
            Comment: row.comment,
        }));
        this.setState({commentsDownloaded: true, Comments: comments});
    }

    async leaveComment(){

        (document.getElementById("nameInput") as HTMLInputElement).value = "";
        (document.getElementById("messageInput") as HTMLInputElement).value = "";
        this.setState({commentsDownloaded: false})

        const {error} = await supabase
            .from('comments')
            .insert({context: this.props.type, author_name: this.name, comment: this.comment});

        if (error) {
            console.log(error);
        }

        this.getComments()

    }
    render() {

        var button = <div className="CommentForm">
            <div className="CommentForm-fields">
                <input id="nameInput" type="text" name="name" className="input" placeholder="Имя"
                       onChange={(e) => {
                           this.name = e.target.value;
                       }}/>
                <input id="messageInput" type="text" name="message" className="input" placeholder="Сообщение"
                       onChange={(e) => {this.comment = e.target.value}}/>
            </div>
            <div className="Items"><MyButton label="Оставить комментарий" myValue={() => {
                this.leaveComment();
            }}></MyButton></div>

        </div>


        if (this.state.commentsDownloaded) {
            return (
                <div>{button}
                    <div className="cards">
                        {
                            (this.state.Comments).map((c,index) => ShowComment(c,index))
                        }
                    </div>
                </div>
            )
        } else {
            return (
                <div>{button}
                    {LoadingImage()}
                </div>
            )
        }
    }

}


function ShowComment(value: Comment, index:number) {

    var className = ((index%2)==0? "cardElement" : "cardElementRight");
    return <div key={index} className={className}>
        <div className="cardText">{value.Name}</div>
        <div className="cardText">{value.Comment}</div>
    </div>

}

function ConvertEmotes(value:string){



}


export default Comments
